<template>
  <div class="ma-3 ml-5">
    <div class="flex ml-3">
      <div class="flex">
        <v-menu
          v-model="menu1"
          :close-on-content-click="false"
          :nudge-right="10"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field dense outlined clearable class="shrink mr-2 mt-3" style="width:180px; height:45px;"
              id="fr_date" 
              ref="fr_date" 
              v-model="fr_date"
              label="부터"
              append-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            no-title locale="ko-KR"
            v-model="fr_date"
            @input="menu1 = false"
          ></v-date-picker>
        </v-menu>
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="10"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field dense outlined clearable class="shrink mr-2  mt-3"  style="width:180px; height:45px;"
              id="to_date" 
              ref="to_date" 
              v-model="to_date"
              label="까지"
              append-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            no-title locale="ko-KR"
            v-model="to_date"
            @input="menu2 = false"
          ></v-date-picker>
        </v-menu>

        <v-btn class="normal-btn" @click="refresh()">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
    
      </div>

      <v-btn class="report__btn mt-4 mr-4" @click="Report()">
        <v-icon size="medium">mdi-file-document</v-icon>
        엑셀다운
      </v-btn>

    </div>

    <div class="mt-3">
      
      <div class="table-container mt-3">
        <v-data-table
          id="time__table"
          :loading="loading" 
          :headers="headers"
          :items="items"
          :items-per-page= "50000"
          class="custom-table"
          no-data-text="자료가 없거나 접근 권한이 없습니다."
          fixed-header
          hide-default-footer>
          <template v-slot:item="{ item }">
              <tr>
                <td class="table_line">{{ item.dt }}</td>
                <!-- <td class="table_line">{{ index+1 }}</td> -->
                <td class="table_line">
                  <span v-if="item.package" style="cursor: pointer;" @click="detailDialog(item)">🔎</span> 
                  <span v-else> </span>
                </td>
                <td class="table_line">{{ item.farmName }}</td>
                <td class="table_line">{{ item.eqpmnName }}</td>
                <td class="table_line">{{ item.fileName }}</td>
                <td class="table_line">{{ item.fromDt }}</td>
                <td class="table_line">{{ item.toDt }}</td>
                <td class="table_line">{{ item.sentCount }} 건 발송</td>
                <td class="table_line">{{ item.makrId }}</td>
                <td class="table_line">{{ item.status }}</td>
              </tr>
            </template>
        </v-data-table>
      </div>
    </div>

    <v-dialog
      v-model="dialog"
      width="1700"
    >
      <v-card
        max-width="1700"
      >
        <div class="dialog-title flex s-bt"> 
          <div>
              <span class="ml-1">{{ detailName }}</span> 축평원 상세 로그

              <v-btn class="report__btn ml-1" @click="detailReport()" style="background-color: white !important; color:#4A5568 !important;">
                <v-icon size="medium">mdi-file-document</v-icon>
                엑셀다운
              </v-btn>
              <span class="ml-2" style="font-size:0.7rem; letter-spacing: -0.25px;">* 전체 다운은 아래 콤보박스 all 선택후 내려받기를 진행해주세요.</span>
          </div>
          <div @click="dialog = false;" style="cursor: pointer;">
            <v-icon color="white">mdi-close</v-icon>
          </div>
        </div>
        
        <div class="pa-5" >
          <div class="table-container">
            <v-data-table
              id="detail__table"
              :loading="dialoading"
              :headers="dialogTableHeaders"
              :items="dialogItems"
              :items-per-page="100"
              class="custom-table"
              no-data-text="자료가 없거나 접근 권한이 없습니다."
              fixed-header
            >
              <template v-slot:item="{ item, index }">
                <tr>
                  <td class="table_line">{{ index + 1 }}</td>
                  <td class="table_line">{{ item.lsindregistno }}</td>
                  <td class="table_line">{{  item.itemcode  }}</td>
                  <td class="table_line">{{  item.makrid  }}</td>
                  <td class="table_line">{{  item.eqpmncode  }}</td>
                  <td class="table_line">{{  item.eqpmnesntlsn  }}</td>
                  <td class="table_line">{{  item.eqpmnno  }}</td>
                  <td class="table_line">{{  item.stalltycode }}</td>
                  <td class="table_line">{{  item.stallno  }}</td>
                  <td class="table_line">{{  item.roomno  }}</td>
                  <td class="table_line">{{  item.roomdtlno  }}</td>
                  <td class="table_line">{{  item.mesuredt  }}</td>
                  <td class="table_line">{{  item.mesureval01  }}</td>
                  <td class="table_line">{{  item.mesureval02  }}</td>
                  <td class="table_line">{{  item.mesureval03  }}</td>
                  <td class="table_line">{{  item.mesureval04  }}</td>
                  <td class="table_line">{{  item.mesureval05  }}</td>
                  <td class="table_line">{{  item.mesureval06  }}</td>
                  <td class="table_line">{{  item.mesureval07  }}</td>
                  <td class="table_line">{{  item.mesureval08  }}</td>
                  <td class="table_line">{{  item.mesureval09  }}</td>
                  <td class="table_line">{{  item.mesureval10  }}</td>
                  <td class="table_line">{{  item.mesureval11  }}</td>
                  <td class="table_line">{{  item.mesureval12  }}</td>
                  <td class="table_line">{{  item.mesureval13  }}</td>
                  <td class="table_line">{{  item.mesureval14  }}</td>
                  <td class="table_line">{{  item.mesureval15  }}</td>
                </tr>
              </template>
            </v-data-table>
    
          </div>
        </div>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import Apis from '@/api/apis';
import dateUtil from "@/utils/custom/dateProperty.js";

import * as Xlsx from 'xlsx'


export default {
  name: 'logList',
  async created() {
    Apis.getIpClient((res) => {
      // console.log(res);  
      let client = res
      Apis.pageCount({ //페이지뷰 카운터
        page_name: `${client.city}/${client.country}/${client.region}/${client.loc}/${client.org}/${client.postal}/${client.timezone}`,
        url: this.$route.path,
        ip: client.ip,
        division: "pigro",
      },() => {  // 정상처리
        // console.log("pageCount 호출",res);
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("pageCount 호출 오류",err);
      });
    }).catch( (err) => {  // API 오류 처리
        console.log("getIpClient 호출 오류",err)
    }) 

    const savedFarm = sessionStorage.getItem("pack_farm");
    if (savedFarm) {
      this.localFarm = JSON.parse(savedFarm);
    }

    let cdate = new Date();
    this.to_date= dateUtil.format(cdate, "yyyy-MM-dd");
    let frdate = new Date(cdate.setDate(cdate.getDate() - 7 ));
    this.fr_date= dateUtil.format(frdate, "yyyy-MM-dd");

    this.refresh();
  },
  data(){
    return {
      menu1: false,
      menu2: false,
      fr_date: "",
      to_date: "",


      headers:[
        { text: '송신일시', align: 'center', sortable: true, value: 'dt',width:'80px' },
        { text: '상세보기', align: 'center', sortable: false, value: '',width:'80px'},
        { text: '농장명', align: 'center', sortable: true, value: 'farmName'},
        { text: '장비', align: 'center', sortable: true, value: 'eqpmnName'},
        { text: '파일이름', align: 'center', sortable: false, value: 'fileName'},
        { text: '부터', align: 'center', sortable: false, value: 'fromDt'},
        { text: '까지', align: 'center', sortable: false, value: 'toDt'},
        { text: '데이터 건수', align: 'center', sortable: false, value: 'sentCount'},
        { text: '업체ID', align: 'center', sortable: true, value: 'makrId'},
        { text: '결과', align: 'center', sortable: true, value: 'status'},
      ],
      items:[],
      
      loading:false,

      dialog : false,
      detailName:'',

      dialoading : false,
      dialogTableHeaders : [
        { text: 'No', value:'', sortable: false,width:'50px', align: 'center' },
        { text: 'lsindRegistNo', value: 'lsindregistno', sortable: false, align: 'center' },
        { text: 'itemcode', value: 'itemcode',width:'120px', align: 'center' },
        { text: 'makrid', value: 'makrid', align: 'center' },
        { text: 'eqpmnCode', value: 'eqpmncode',width:'140px', align: 'center' },
        { text: 'eqpmnEsntlSn', value: 'eqpmnesntlsn',width:'150px', align: 'center' },
        { text: 'eqpmnNo', value: 'eqpmnno',width:'120px', align: 'center'  },
        { text: 'stallTyCode', value: 'stalltycode',width:'140px' , align: 'center' },
        { text: 'stallNo', value: 'stallno',width:'120px', align: 'center'  },
        { text: 'roomNo', value: 'roomno',width:'120px', align: 'center'  },
        { text: 'roomDtlNo', value: 'roomdtlno',width:'120px', align: 'center'  },
        { text: 'mesureDt', value: 'mesuredt', align: 'center' },
        { text: 'mesureVal01', value: 'mesureval01',width:'140px' , align: 'center' },
        { text: 'mesureVal02', value: 'mesureval02',width:'140px' , align: 'center' },
        { text: 'mesureVal03', value: 'mesureval03',width:'140px' , align: 'center' },
        { text: 'mesureVal04', value: 'mesureval04',width:'140px' , align: 'center' },
        { text: 'mesureVal05', value: 'mesureval05',width:'140px' , align: 'center' },
        { text: 'mesureVal06', value: 'mesureval06',width:'140px'  , align: 'center'},
        { text: 'mesureVal07', value: 'mesureval07',width:'140px'  , align: 'center'},
        { text: 'mesureVal08', value: 'mesureval08',width:'140px' , align: 'center' },
        { text: 'mesureVal09', value: 'mesureval09',width:'140px' , align: 'center' },
        { text: 'mesureVal10', value: 'mesureval10',width:'140px' , align: 'center' },
        { text: 'mesureVal11', value: 'mesureval11',width:'140px' , align: 'center' },
        { text: 'mesureVal12', value: 'mesureval12',width:'140px'  , align: 'center'},
        { text: 'mesureVal13', value: 'mesureval13',width:'140px' , align: 'center' },
        { text: 'mesureVal14', value: 'mesureval14',width:'140px' , align: 'center' },
        { text: 'mesureVal15', value: 'mesureval15',width:'140px' , align: 'center' },
      ],
      dialogItems: [],
      dialogHeadrs: {},

    }
  },
  methods:{
    refresh(){
      this.loading= true;
      Apis.listExtDataSendLog({
        "from" : this.fr_date,
        "to" : this.to_date
      }, (res) => {
        if (res.result) { 
          this.items = res.data;
        }
        this.loading= false;

      }).catch((err) => {
        console.error("listExtDataSendLog 오류", err);
      });
    },
    detailDialog(item){
      // console.log(item)
      this.dialog = true;
      this.dialoading = true;

      Apis.listConvertDataOfPackage({
        "lsindRegistNo" : item.lsindRegistNo,
        "eqpmnCode" : item.eqpmnCode,
        "fromDt" :  item.fromDt,
        "toDt" : item.toDt
      }, (res) => {
        if (res.result) { 
          this.detailName = item.farmName;
          this.dialogHeadrs = res.data.headers || {};
          this.dialogItems = res.data.convert_list || [];

          // this.dialogTableHeaders = Object.keys(this.dialogHeadrs).map(k => ({
          //   text: String(this.dialogHeadrs[k]).trim(), 
          //   value: k,                                 
          //   sortable: true,
          //   align: 'center',
          //   width: '150px'
          // }));

          this.dialoading = false;
        } else {
          this.dialogHeadrs = {};
          this.dialogItems = [];
          this.dialogTableHeaders = [];

          this.dialoading = false;

        }

      }).catch((err) => {
        console.error("listConvertDataOfPackage 오류", err);
      });

    },
    Report(){
      let today = new Date();   
      let hours = today.getHours();
      let minutes = today.getMinutes();  

      const excelData = Xlsx.utils.table_to_sheet(document.getElementById('time__table')); // table id
      const workBook = Xlsx.utils.book_new(); // 새 시트 생성 
      Xlsx.utils.book_append_sheet(workBook, excelData, '지표데이터');  // 시트 명명, 데이터 지정
      Xlsx.writeFile(workBook, `축평원 전송 데이터_${hours}시 ${minutes}분.xlsx`); // 엑셀파일 만듬
    },
    detailReport(){
      let today = new Date();   
      let hours = today.getHours();
      let minutes = today.getMinutes();  

      const excelData = Xlsx.utils.table_to_sheet(document.getElementById('detail__table')); // table id
      const workBook = Xlsx.utils.book_new(); // 새 시트 생성 
      Xlsx.utils.book_append_sheet(workBook, excelData, '지표데이터');  // 시트 명명, 데이터 지정
      Xlsx.writeFile(workBook, `농장별 축평원 전송 데이터_${hours}시 ${minutes}분.xlsx`); // 엑셀파일 만듬
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/base.scss';
.normal-btn{
  width: 40px !important;
  height: 40px !important;
  border-radius: 50% !important;
  min-width: unset !important;
  background-color:#E3F2FD !important;
  margin-left:5px;
  margin-top:10px;
}
.table-container {
  width: 100%; 
  max-width: 100%; 
  height: 80vh;
  
  overflow: auto; 
  
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  border: 1px solid #ddd;
  background-color: white;
}
.dialog-title{
  padding:15px;
  background-color: #4A5568;
  color:white;
  font-weight:600;
}
::v-deep .v-data-table-header tr th{
  background-color: #4A5568 !important;
  color:white !important;
  font-size:0.85rem !important;
}
table {
  min-width: 100%; 
  
  table-layout: auto; 
  
  border-spacing: 0;
  border-collapse: separate; 
}

thead {
  position: sticky;
  top: 0;
}

thead th {
  background-color: #4A5568;
  color: white;
  padding: 12px 10px;
  
  white-space: nowrap; 
  
  border-bottom: 1px solid #ddd;
  border-right: 1px solid #4A5568;
}

tbody td {
  padding: 8px 10px;
  background-color: white;
  border-bottom: 1px solid #ddd;
  border-right: 1px solid #ddd;
  text-align: center;
  
  white-space: nowrap; 
}

tbody td:last-child, thead th:last-child {
  border-right: none;
}

.report__btn{
  background-color:#4A5568 !important;
  color:white;
  letter-spacing: -1px;
  border-radius: 30px;
  min-width:95px;
  max-height:60px;
}

::v-deep #detail__table .v-data-table__wrapper {
  overflow-x: scroll !important;
  overflow-y: auto !important;
  white-space: nowrap !important;
}

::v-deep #detail__table table {
  min-width: max-content !important; 
}
</style>